import LocationOnRounded from '@mui/icons-material/LocationOnRounded';
import { Box, IconButton, SxProps, Tooltip } from '@mui/material';
import React, { FC } from 'react';

import { tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';
import { CapturePiece } from '@components/Capture/types';

interface ILocationIconProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
}

const LocationIcon: FC<ILocationIconProps> = ({ onClick, capturePiece }) => {
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;
  const disabled = !piece;

  return (
    <Tooltip title={tooltips.LocationOnRounded} arrow>
      <Box component="span">
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={tooltips.LocationOnRounded}
          sx={{ ...CommonStyles, ...sxMR0 } as SxProps}
        >
          <LocationOnRounded sx={StyledIcon(disabled ? 'action.disabled' : undefined)} />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export { LocationIcon };
